/* CÍL, JEHOŽ ČÁSTKU PLÁN DOPOČÍTÁ (průvodce analýzou, 12.–13. 10. 2026)
 * ============================================================================
 * JEDNA PRAVDA pro tři místa:
 *   · povinné minimum „Cíl“ (minimumPlanu.js, brána „Připraveno na plán?“),
 *   · „chybí částku“ v kroku Cíle (pruvodce.js) — u renty se nehlásí,
 *   · fáze schůzky „Cíle“ (stavFazi v model.js) → fajfka v liště průvodce,
 *     čip prezentace (hotoveKroky) i nový CRM. Rozhodnutí hlavní relace
 *     13. 10. 2026 (CX2-10): „krok Cíle je hotový, i když cíl renty plán
 *     dopočítá — jedno měřítko ve stavFazi“. Dřív minimum Cíl dopočtem prošlo,
 *     ale krok Cíle zůstal „nezačato“ — dvě odpovědi na jednu otázku.
 *
 * Samostatný modul, protože ho čte model.js: z minimumPlanu.js / stavy.js by
 * import udělal kruh (stavy.js čte šablonu z model.js už při načtení).
 * Závislosti: bilance + planSolver (model.js je už má v grafu přes
 * volneCashflow) a sablonaCilu.js (bez importů).
 *
 * Neznámé ≠ 0: všechno se pozná jen z toho, co poradce zapsal.
 */
import { asObj } from "@/lib/bezpecneHodnoty";
import { nezbytneVydaje } from "@/lib/bilance";
import { jeRezerva } from "@/lib/planSolver";
import { jeSablonaCile } from "./sablonaCilu";
/* Potřeba renty (výdaje − vklady + splátky) — závislosti bilance
 * a doporuceniCile jsou v grafu už přes planSolver, kruh nehrozí. */
import { potrebaRenty } from "./potrebaRenty";

const num = (v) => (Number.isFinite(+v) ? +v : 0);

/** Má cíl termín? Šablonový termín (0/5/15/25) platí jako zadaný. */
export function maTerminCile(c) {
  const r = asObj(c).roky;
  if (r === 0) return true;
  if (r === null || r === undefined || String(r).trim() === "") return false;
  return Number.isFinite(+r) && +r >= 0;
}

/**
 * Dopočítá plán částku cíle sám? Jen pro výklad „chybí částka“:
 *   renta (`mesicne === true`) — plán ji počítá z výdajů a splátek
 *     (potrebaRenty), takže JEN když je z čeho: bez výdajů i splátek vrací
 *     potrebaRenty null a renta se nedopočítá (nález R4, 14. 10. 2026 —
 *     dřív dostal krok Cíle fajfku i bez výdajů a brána ho držela jen řádkem
 *     minima Výdaje),
 *   rezerva — plán ji počítá z NEZBYTNÝCH výdajů, pokud jsou zadané.
 * @returns {"renta"|"rezerva"|null}
 */
export function castkaSeDopocita(d, c) {
  const cil = asObj(c);
  if (cil.mesicne === true) return potrebaRenty(asObj(d), { cil }) != null ? "renta" : null;
  if (jeRezerva(cil) && nezbytneVydaje(asObj(d)) != null) return "rezerva";
  return null;
}

/**
 * Splní cíl BEZ částky minimum dopočtem? Jen cíl, na který poradce sáhl
 * (ne nedotčená šablona), s termínem a s dopočitatelnou částkou.
 * „renta“ = rentaZAnalyzy ≠ null (renta() vrací null jen bez výdajů
 * i splátek) — podmínka žije v `castkaSeDopocita`.
 * @returns {"renta"|"rezerva"|null}
 */
export function dopocetCile(d, c) {
  const cil = asObj(c);
  if (num(cil.hodnota) > 0) return null;
  if (jeSablonaCile(cil) || !maTerminCile(cil)) return null;
  return castkaSeDopocita(d, cil);
}
